export class SecretRefInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRefInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
